import { render, staticRenderFns } from "./wxAppManage.vue?vue&type=template&id=948883d8&scoped=true"
import script from "./wxAppManage.vue?vue&type=script&lang=js"
export * from "./wxAppManage.vue?vue&type=script&lang=js"
import style0 from "./wxAppManage.vue?vue&type=style&index=0&id=948883d8&prod&lang=less&scoped=true"
import style1 from "./wxAppManage.vue?vue&type=style&index=1&id=948883d8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "948883d8",
  null
  
)

export default component.exports